export function AnimatedHeroBackground() {
  return (
    <div
      className="absolute inset-0 overflow-hidden pointer-events-none"
      aria-hidden="true"
    >
      {/* CSS-only gradient mesh – 3 animated radial glows */}
      <div className="absolute w-[60vw] h-[60vh] top-[5%] left-[10%] rounded-full bg-primary/[0.10] blur-[120px] animate-mesh-drift-1" />
      <div className="absolute w-[50vw] h-[50vh] top-[35%] right-[0%] rounded-full bg-primary/[0.07] blur-[100px] animate-mesh-drift-2" />
      <div className="absolute w-[40vw] h-[40vh] bottom-[0%] left-[25%] rounded-full bg-emoose-green-light/[0.05] blur-[80px] animate-mesh-drift-3" />
    </div>
  );
}
